module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fzIug"))).then(() => parcelRequire('d0iPb'));